<div class="container-fluid p-0" *ngIf="isLoaded()">
  <div class="row m-l-sm p-0" *ngIf="this.task&&this.task.division">
    <!-- zona de widgets -->
    <!-- WIDGET OFERTAS RECIIDAS -->
    <div class="widget-container col-12 col-md-4">
      <div class="widget row style1 bg-success text-light">
        <div class="col-4" style="display:inline-block;">
          <i class="fas fa-5x fa-check"></i>
        </div>
        <div class="col-8 float-right">
          <span>{{ 'Invoices.budget.amountInvoiced' | translate }}</span>
          <h2 class="font-bold {{this.totalFacturado>this.totalAdjudicado?'text-danger':''}} "> {{ this.totalFacturado |
            currency:'EUR'}} </h2>
        </div>
      </div>
    </div>
    <!-- WIDGET LOTES PENDIENTES DE ADJUDICAR -->
    <div class="widget-container col-12 col-md-4">
      <div class="widget row style1 bg-warning">
        <div class="col-4" style="display:inline-block;">
          <i class="far fa-5x fa-clock"></i>
        </div>
        <div class="col-8 float-right">
          <span>{{ 'Invoices.budget.amountPending' | translate }} </span>
          <h2 class="font-bold"> {{this.totalFacturado>this.totalAdjudicado?(0|
            currency:'EUR'):(this.totalAdjudicado-this.totalFacturado| currency:'EUR')}} </h2>
        </div>
      </div>
    </div>
    <!-- WIDGET CONTRATOS CREADOS -->
    <div class="widget-container col-12 col-md-4">
      <div class="widget row style1 bg-info">
        <div class="col-4" style="display:inline-block;">
          <i class="fas fa-5x fa-hand-holding-usd"></i>
        </div>
        <div class="col-8 float-right">
          <span> {{ 'Invoices.budget.totalAmount' | translate }} </span>
          <h2 class="font-bold"> {{ this.totalAdjudicado | currency:'EUR'}} </h2>
        </div>
      </div>
    </div>
  </div>
  <div class="row col-12" *ngIf="contractName">
    <div class="titleElement"> {{'Settlement.contract' | translate}}: {{contractName}} </div>
  </div>
  <div class="row p-0">
    <div class="col-12 m-t-md" *ngIf="isLoaded()">
      <div class="alert alert-info col-12" *ngIf="!nifs||nifs.length==0">
        <span><i class="fas fa-info-circle mr-2" aria-hidden="true"></i>{{ 'General.noData' | translate }}</span>
      </div>
      <p-panel class="mb-3" [toggleable]="true" *ngFor="let nif of nifs">
        <p-header>
          <span>
            <i class="fas fa-lg  fa-building"></i>
            <span class="m-l-sm">{{mapResult.get(nif)[0].taxIdentifier}} -
              {{mapResult.get(nif)[0]?.company?.name}}</span>
          </span>
        </p-header>
        <p-table [value]="mapResult.get(nif)" [responsive]="true" sortField="plannedPeriod.inDate" sortOrder="1">
          <ng-template pTemplate="header">
            <tr>
              <th [style.width]="'15%'">{{'Invoices.number'|translate}}</th>
              <th [style.width]="'15%'">{{'Invoices.serialNumber'|translate}}</th>
              <th [style.width]="'25%'">{{'General.description'|translate}}</th>
              <th [style.width]="'5%'">{{'Invoices.totalAmount'|translate}}</th>
              <th [style.width]="'20%'" class="text-center">{{'DocumentState.state'|translate}}</th>
              <th class="action-button text-center">{{'General.actions'|translate}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-invoice>
            <tr>
              <td>
                <span class="p-column-title">{{'Invoices.number'|translate}}</span> {{ invoice.number }}
              </td>
              <td>
                <span class="p-column-title">{{'Invoices.serialNumber'|translate}}</span> {{ invoice.serialNumber }}
              </td>
              <td class="text-truncate">
                <span class="p-column-title">{{'General.description'|translate}}</span> {{ invoice.description }}
              </td>
              <td
                [ngClass]="(invoice.document.currentState.identifier !== 'ANULADO' && invoice.document.currentState.identifier != 'RECTIFICADA')?'':'text-warning'">
                <span class="p-column-title">{{'Invoices.totalAmount'|translate}}</span> {{invoice.totalAmount |
                currency:'EUR'}}
              </td>
              <td class="text-center">
                <span class="p-column-title">{{'DocumentState.state'|translate}}</span>
                <span *ngIf="invoice.document.currentState&&invoice.document.currentState.type"
                  [ngClass]="getStatusColor(invoice.document.currentState)">
                  {{invoice.document.currentState.type.description}}</span>
              </td>
              <td>
                <div class=" float-right d-flex justify-content-end text-right">
                  <div class=" btn-group">
                    <button class="btn btn-sm btn-primary t-action-button" aria-expanded="false"
                      title="{{ 'Invoices.edit.tooltip' | translate}}"
                      (click)="edit(invoice.identifier, invoice.externalCode? true: false)"
                      disabled="{{isShowEdit(invoice)?'':'disabled'}}">
                      <i class="fas {{invoice.externalCode? 'fa-info-circle' : 'fa-pencil-alt'}}"
                        aria-hidden="true"></i>
                    </button>
                    <button class="btn btn-sm btn-primary t-action-button" aria-expanded="false"
                      title="{{ 'Invoices.rectify.tooltip' | translate}}" (click)="rectify(invoice.identifier)"
                      disabled="{{isShowRectify(invoice)?'':'disabled'}}">
                      <i class="fas fa-redo-alt" aria-hidden="true"></i>
                    </button>
                    <button class="btn btn-sm btn-primary t-action-button" aria-expanded="false"
                      title="{{ 'Invoices.reject.tooltip' | translate}}" (click)="reject(invoice.identifier)"
                      disabled="{{isShowReject(invoice)?'':'disabled'}}">
                      <i class="fas fa-times" aria-hidden="true"></i>
                    </button>
                  </div>
                  <div class=" btn-group m-l-xs">
                    <button class="btn btn-sm btn-primary t-action-button" aria-expanded="false"
                      disabled="{{(invoice.document&&invoice.document.identifier)?'':'disabled'}}"
                      title="{{ 'Invoices.view.tooltip' | translate}}" (click)="showDocument(invoice.document)">
                      <i class="fas fa-eye" aria-hidden="true"></i>
                    </button>
                  </div>
                  <!--button class="btn btn-sm btn-primary t-action-button" aria-expanded="false" title="{{ 'General.edit' | translate}}" (click)="edit(invoice.identifier)">
                      <i class="fas fa-pencil-alt"  aria-hidden="true"></i>
                    </button-->
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr class="text-center">
              <td colspan="5"><span>{{ 'General.noData' | translate }}</span></td>
            </tr>
          </ng-template>
        </p-table>
      </p-panel>
    </div>
  </div>
</div>